var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntsgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.241 25A12.096 12.096 0 1 1 14.67 1.056c.439.088.872.201 1.298.339a.406.406 0 0 1-.249.773 11.443 11.443 0 0 0-3.477-.545 11.274 11.274 0 1 0 9.956 5.972.408.408 0 0 1 .478-.58c.103.031.19.102.24.198A12.1 12.1 0 0 1 12.242 25Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.418 4.976a.4.4 0 0 1-.29-.116c-.289-.285-.593-.554-.912-.805-.244-.195-.499-.38-.757-.55a.408.408 0 0 1 .453-.679c.275.185.547.382.808.58.343.27.67.56.98.869a.4.4 0 0 1 0 .58.398.398 0 0 1-.282.121ZM14.71 6.758H9.74a3.665 3.665 0 0 0-3.662 3.663v4.963a3.665 3.665 0 0 0 3.663 3.663h4.97a3.665 3.665 0 0 0 3.661-3.663v-4.963a3.665 3.665 0 0 0-3.662-3.663Zm-2.469 9.327a3.187 3.187 0 1 1 0-6.374 3.187 3.187 0 0 1 0 6.374Zm3.188-5.574a.761.761 0 1 1 .28-.053.761.761 0 0 1-.298.053h.018Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntsgram);
export default __webpack_public_path__ + "static/media/intsgram.f7535541c0e8714ac4b3a963ff0ef771.svg";
export { ForwardRef as ReactComponent };